import React, { lazy, useState } from 'react'
import GiftVoucherModal from 'src/ui/Modals/GiftVoucherModal/GiftVoucherModal'
import { Flex } from '@chatterbug/aaron'
import HomePlaceholder from 'src/pages/Home/HomePlaceholder'
import LoadPage from 'src/ui/LoadPage/LoadPage'
import BannerTrial from 'src/ui/Banner/BannerTrial/BannerTrial'
import {
  PAGE_HORIZONTAL_PADDING,
  MAX_WIDTHS_FOR_BREAKPOINTS,
} from 'src/ui/PageLayout/PageLayout'

const HomeLazy = lazy(() =>
  import(/* webpackChunkName: "HomeLazy" */ './HomeLazy')
)

const LoadPageHome = (props) => {
  const [prioritizeModal, setPrioritizeModal] = useState(
    !!props.giftVoucherRedemptionModalType || false
  )

  const handleCloseModal = () => {
    setPrioritizeModal(false)
  }

  return (
    <>
      <LoadPage
        headerSection={
          props.trialEnd && (
            <Flex
              px={PAGE_HORIZONTAL_PADDING}
              alignItems="center"
              mx="auto"
              mb="2x"
              maxWidth={MAX_WIDTHS_FOR_BREAKPOINTS}
            >
              <BannerTrial trialEndAt={props.trialEnd} />
            </Flex>
          )
        }
        LazyPage={HomeLazy}
        Placeholder={HomePlaceholder}
        showBreadcrumbs={false}
        showProductTour={!prioritizeModal}
        {...props}
      />
      {prioritizeModal && (
        <GiftVoucherModal
          isSuccess={props.giftVoucherRedemptionModalType === 'success'}
          isOpen
          isEligibleForLiveLessons={props.isEligibleForLiveLessons}
          onHide={handleCloseModal}
          voucherRedeemUrl={props.voucherRedeemUrl}
        />
      )}
    </>
  )
}

export default LoadPageHome
